if (!window.reaCartDrawerRefreshInit) {
  window.reaCartDrawerRefreshInit = true;

  // Cards across all seed fetches beyond this are dropped after dedup, so
  // the carousel can't grow unbounded (4 seeds x up to 4 each = 16 max).
  const MAX_DISPLAYED = 16;
  const RECOMMENDATION_LIMIT_PER_SEED = 4;

  const refreshShippingBar = (freshDrawerHTML) => {
    const fresh = freshDrawerHTML.querySelector('.cart-drawer__shipping-bar');
    const live = document.querySelector('.cart-drawer__shipping-bar');
    if (fresh && live) live.replaceWith(fresh);
  };

  const fetchRecommendationCards = (baseUrl, sectionId, productId) => {
    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('limit', RECOMMENDATION_LIMIT_PER_SEED);
    url.searchParams.set('intent', 'complementary');
    url.searchParams.set('product_id', productId);
    url.searchParams.set('section_id', sectionId);
    return fetch(url.toString())
      .then((response) => {
        if (!response.ok) {
          console.error('[rea-cart-drawer-refresh] recommendation fetch not ok', productId, response.status);
        }
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return Array.from(doc.querySelectorAll('.cart-drawer__recommendations-item'));
      })
      .catch((error) => {
        console.error('[rea-cart-drawer-refresh] recommendation fetch failed', productId, error);
        return [];
      });
  };

  // Dawn's own product-recommendations custom element only supports one
  // seed product per instance. The cart can hold several different
  // products, and recommendations should accumulate across all of them
  // (deduplicated) rather than being replaced by whichever was added last —
  // so this fetches each seed independently and merges the results itself.
  const refreshRecommendations = (freshDrawerHTML) => {
    const fresh = freshDrawerHTML.querySelector('[data-cart-recommendations]');
    const live = document.querySelector('[data-cart-recommendations]');
    if (!fresh || !live) return;

    const seedIds = (fresh.dataset.productIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);

    if (!seedIds.length) return;

    live.dataset.productIds = fresh.dataset.productIds;
    const baseUrl = live.dataset.url;
    const sectionId = live.dataset.sectionId;

    Promise.all(seedIds.map((id) => fetchRecommendationCards(baseUrl, sectionId, id)))
      .then((resultsBySeed) => {
        const seen = new Set();
        const merged = [];
        resultsBySeed.forEach((items) => {
          items.forEach((item) => {
            const productId = item.dataset.productId;
            if (seen.has(productId)) return;
            seen.add(productId);
            merged.push(item);
          });
        });

        const list = live.querySelector('[data-cart-recommendations-list]');
        const heading = live.querySelector('[data-cart-recommendations-heading]');
        if (!list) return;

        list.innerHTML = '';
        merged.slice(0, MAX_DISPLAYED).forEach((item) => list.appendChild(item));
        if (heading) heading.classList.toggle('hidden', merged.length === 0);
        live.classList.toggle('cart-drawer__recommendations--empty', merged.length === 0);
      })
      .catch((error) => {
        console.error('[rea-cart-drawer-refresh] recommendations merge failed', error);
      });
  };

  const refresh = () => {
    const shippingBar = document.querySelector('.cart-drawer__shipping-bar');
    const recommendations = document.querySelector('[data-cart-recommendations]');
    if (!shippingBar && !recommendations) return;

    fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        refreshShippingBar(html);
        refreshRecommendations(html);
      })
      .catch((error) => {
        console.error('[rea-cart-drawer-refresh] refresh fetch failed', error);
      });
  };

  // Run once on load too — not just on cartUpdate — so a returning visitor
  // who already has items in their cart sees recommendations immediately,
  // rather than only after their next add.
  refresh();

  // subscribe/publish (pubsub.js) are plain function declarations, so they
  // land on window — but PUB_SUB_EVENTS (constants.js) is declared with
  // `const`, which creates a script-scope global binding, not a window
  // property. window.PUB_SUB_EVENTS is therefore always undefined
  // regardless of script load order; the bare identifier is what every
  // other Dawn script (global.js, cart.js) actually uses.
  if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  } else {
    console.error('[rea-cart-drawer-refresh] PUB_SUB_EVENTS/subscribe unavailable, cart-update refresh will not fire');
  }
}
